import apiClient from "../config/api";

/**
 * Get plates by status
 * @param {string} status - Plate status (pending, approved, reported, etc.)
 * @returns {Promise} API response with plates data
 */
export const getPlatesByStatus = async (status) => {
  try {
    const response = await apiClient.get(`/plates-by-status?status=${status}`);
    return response.data;
  } catch (error) {
    console.error("getPlatesByStatus error:", error);
    throw error;
  }
};

/**
 * Resolve/Approve a plate claim
 * @param {string} plateId - Plate ID to resolve/approve
 * @returns {Promise} API response
 */
export const resolvePlate = async (plateId) => {
  try {
    const response = await apiClient.put(`/plate/${plateId}/resolve`);
    return response.data;
  } catch (error) {
    console.error("resolvePlate error:", error);
    throw error;
  }
};

/**
 * Reject a plate claim
 * @param {string} plateId - Plate ID to reject
 * @param {Object} rejectData - Rejection data
 * @param {string} rejectData.subject - Rejection subject/reason
 * @param {string} rejectData.message - Rejection message
 * @returns {Promise} API response
 */
export const rejectPlateClaim = async (plateId, rejectData) => {
  try {
    const response = await apiClient.put(
      `/plate/${plateId}/reject-claim`,
      rejectData
    );
    return response.data;
  } catch (error) {
    console.error("rejectPlateClaim error:", error);
    throw error;
  }
};

/**
 * Request more information for a plate claim
 * @param {string} plateId - Plate ID
 * @param {Object} requestData - Request data
 * @param {string} requestData.message - Request message
 * @returns {Promise} API response
 */
export const requestMoreInfo = async (plateId, requestData) => {
  try {
    const response = await apiClient.put(
      `/plate/${plateId}/request-more-info`,
      requestData
    );
    return response.data;
  } catch (error) {
    console.error("requestMoreInfo error:", error);
    throw error;
  }
};

/**
 * Revoke plate verification status
 * @param {string} plateId - Plate ID to revoke
 * @param {Object} revokeData - Revoke data
 * @param {string} revokeData.subject - Revoke subject/reason
 * @param {string} revokeData.message - Revoke message
 * @returns {Promise} API response
 */
export const revokePlateStatus = async (plateId, revokeData) => {
  try {
    const response = await apiClient.put(
      `/plate/${plateId}/revoke-status`,
      revokeData
    );
    return response.data;
  } catch (error) {
    console.error("revokePlateStatus error:", error);
    throw error;
  }
};

/**
 * Suspend a plate
 * @param {string} plateId - Plate ID to suspend
 * @param {Object} suspendData - Suspend data
 * @param {number} suspendData.duration - Suspension duration in days
 * @param {string} suspendData.reason - Suspension reason
 * @returns {Promise} API response
 */
export const suspendPlate = async (plateId, suspendData) => {
  try {
    const response = await apiClient.put(
      `/plate/${plateId}/suspend`,
      suspendData
    );
    return response.data;
  } catch (error) {
    console.error("suspendPlate error:", error);
    throw error;
  }
};

/**
 * Delete a plate
 * @param {string} plateId - Plate ID to delete
 * @returns {Promise} API response
 */
export const deletePlate = async (plateId) => {
  try {
    const response = await apiClient.delete(`/plate/${plateId}`);
    return response.data;
  } catch (error) {
    console.error("deletePlate error:", error);
    throw error;
  }
};

